import { forwardRef } from 'react';
import type React from 'react';

type OwnProps = React.SVGProps<SVGSVGElement> & {
  fill?: string;
  hollow?: boolean;
};

const EVPlugIcon = forwardRef<SVGSVGElement, OwnProps>(
  ({ hollow = false, ...rest }, ref) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={100}
      height={100}
      viewBox="0 0 100 100"
      fill="none"
      ref={ref}
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.1283 20.9585H69.5242L69.536 20.9586C72.0922 20.9747 74.4913 22.0613 76.2276 23.9043C77.9571 25.74 78.8997 28.1809 78.9137 30.6876L78.9138 30.6996L78.9026 43.7279C79.0902 46.5508 79.2844 54.8309 74.1295 62.8557L74.1196 62.871L74.1096 62.8862C71.4114 66.9979 67.7816 70.3614 63.5268 72.6574L63.5178 72.6622C50.968 79.3901 38.2378 73.6452 36.3243 72.7605L36.2069 72.7062L36.0936 72.644C26.5874 67.4216 21.5053 58.7676 20.7474 47.6301L20.7388 47.5036V30.698L20.7388 30.6876C20.7529 28.1809 21.6955 25.74 23.4249 23.9043C25.1612 22.0613 27.5604 20.9747 30.1166 20.9586L30.1283 20.9585ZM30.1553 28.4207C29.7116 28.4258 29.2399 28.6137 28.8557 29.0216C28.4637 29.4377 28.2062 30.0444 28.2004 30.7211V47.2467C28.827 55.9949 32.6181 62.1761 39.572 66.0406C41.6248 66.9746 51.0607 70.871 59.9886 66.0875C63.1149 64.3994 65.8248 61.9054 67.8616 58.8069C71.7818 52.693 71.6012 46.2614 71.4501 44.1159L71.4407 43.9834L71.4522 30.7199C71.446 30.0436 71.1886 29.4374 70.7969 29.0216C70.4126 28.6137 69.941 28.4258 69.4973 28.4207H30.1553Z"
        fill="#0D375E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M48.2017 35.7771C47.9193 35.7771 47.616 35.8614 47.3829 36.0937C47.1496 36.3263 47.0646 36.6297 47.0646 36.9127V39.3272C44.359 40.1421 42.9688 42.3492 42.9688 44.5652C42.9688 46.2832 43.6892 47.5243 44.7325 48.4701C45.7477 49.3905 47.0792 50.0405 48.3188 50.6181L48.3216 50.6193C49.1957 51.0215 49.8194 51.3703 50.2205 51.7155C50.6058 52.0472 50.7264 52.3218 50.7264 52.5963C50.7264 52.9816 50.3457 53.4617 49.4494 53.4617C48.0058 53.4617 46.7894 52.6774 46.1241 52.2C45.8533 52.0042 45.5168 51.9116 45.1796 51.9701C44.8355 52.0297 44.5392 52.2392 44.3558 52.5526L43.2111 54.5901L43.2062 54.5992C43.0612 54.8677 42.9928 55.1578 43.052 55.453C43.1094 55.7392 43.2689 55.9391 43.3955 56.0653L43.4056 56.0748C44.0602 56.6991 45.2775 57.4767 47.0646 57.8894V60.2758C47.0646 60.5588 47.1496 60.8621 47.3829 61.0947C47.616 61.3271 47.9193 61.4114 48.2017 61.4114H50.7786C51.0611 61.4114 51.3643 61.3271 51.5974 61.0947C51.8307 60.8621 51.9158 60.5588 51.9158 60.2758V57.8353C54.6517 57.0182 56.3372 54.7278 56.3372 52.3799C56.3372 50.4728 55.4959 49.1599 54.3636 48.2037C53.3621 47.3579 52.1104 46.775 51.0462 46.2794C50.9437 46.2316 50.843 46.1847 50.7444 46.1385L50.7411 46.137C49.804 45.7037 49.1419 45.3564 48.7169 45.0334C48.2915 44.7102 48.2268 44.5061 48.2268 44.3759C48.2268 44.1796 48.2958 44.0156 48.4272 43.8959C48.5605 43.7745 48.818 43.6457 49.2868 43.6457C49.8495 43.6457 50.4803 43.8419 51.0723 44.1131C51.6557 44.3803 52.1527 44.6974 52.4362 44.8902L52.4417 44.8938C52.831 45.1525 53.2475 45.2077 53.6213 45.1031C53.9721 45.005 54.2419 44.7792 54.4071 44.5441L55.6859 42.6182C55.8199 42.4267 55.9238 42.1554 55.8933 41.8445C55.8606 41.5097 55.6794 41.2122 55.3876 40.9885C54.5989 40.3857 53.3949 39.6957 51.9158 39.2919V36.9127C51.9158 36.6297 51.8307 36.3263 51.5974 36.0937C51.3643 35.8614 51.0611 35.7771 50.7786 35.7771H48.2017Z"
        fill="#0D375E"
        className={hollow ? 'hidden' : ''}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M53.5868 70.1626V87.8541C53.5868 88.5409 53.03 89.0977 52.3432 89.0977H47.3688C46.682 89.0977 46.1252 88.5409 46.1252 87.8541V70.1626H53.5868Z"
        fill="#0D375E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M63.255 10.6689C63.9418 10.6689 64.4986 11.2257 64.4986 11.9125V28.192H57.0364V11.9125C57.0364 11.2257 57.5932 10.6689 58.28 10.6689L63.255 10.6689Z"
        fill="#0D375E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.1549 10.6689C41.8417 10.6689 42.3985 11.2257 42.3985 11.9125V28.192H34.9363V11.9125C34.9363 11.2257 35.4931 10.6689 36.1799 10.6689L41.1549 10.6689Z"
        fill="#0D375E"
      />
      <defs>
        <clipPath id="clip0_497_2170">
          <rect
            width={59}
            height={80}
            fill="white"
            transform="translate(20 10)"
          />
        </clipPath>
      </defs>
    </svg>
  )
);

export default EVPlugIcon;
